import Component from './serial_code_import_reset.vue'
export default Component
